import { Nullable } from 'global';

import { DealSheetFormValues } from './types';
import { dealSheetInitialFormValues } from './constants';
import { DealSheetConfigurationViewModel } from '../../types';

export function getInitialValues(config: Nullable<DealSheetConfigurationViewModel>): DealSheetFormValues {
  if (!config) return dealSheetInitialFormValues;

  return {
    name: config.name,
    description: config.description ?? '',

    taxes: config.charges.data
      .filter(charge => charge.type !== 'CHARGE')
      .map(charge => ({
        ...charge,
        isEquipmentLvl: !!charge.equipmentId,
      })),

    charges: config.charges.data
      .filter(charge => charge.type !== 'TAX')
      .map(charge => ({
        ...charge,
        isEquipmentLvl: !!charge.equipmentId,
      })),

    equipment: {
      ...dealSheetInitialFormValues.equipment,
      ...(config.dealRules.equipment ?? {}),
    },

    customer: {
      ...dealSheetInitialFormValues.customer,
      ...(config.dealRules.customer ?? {}),
    },

    address: {
      ...dealSheetInitialFormValues.address,
      ...(config.dealRules.location ?? {}),
      country: Array.isArray(config.dealRules.location?.country)
        ? config.dealRules.location.country[0]
        : dealSheetInitialFormValues.address.country,
    },
  };
}
